import React, { useState, useEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import validator from 'validator';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import { toast } from 'react-toastify';
import Navbar from '../../components/common/Navbar';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import ButtonMain from '../../components/common/ButtonMain';
import './style.css';
import PasswordField from '../../components/common/passwordInput';
import { CoUserAcceptInvitationApi } from '../../store/features/CoUserAcceptInvitation';
import { validateInvitationApi } from '../../store/features/AppValidateInvitation';

function AgentPassword(props) {
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [stateName, setStateMethod] = useState({
    firstPassword: '',
    firstPasswordInvalidError: false,
    firstPasswordInvalid: '',
    secondPassword: '',
    secondPasswordInvalidError: '',
    secondPasswordInvalid: false,
    FormSubmitting: false,
    firstPasswordState: false,
    secondPasswordState: false,
    showPassword: false,
  });
  const [isValidating, setIsValidating] = useState(true);
  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage,
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage],
  );
  props;
  const ValidatePassword = (password) => {
    if (
      validator.isStrongPassword(password, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      return true;
    }
    return false;
  };
  const handleChange = async (event) => {
    switch (event.target.name) {
      case 'firstPassword':
        if (!ValidatePassword(event.target.value)) {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            firstPasswordInvalidError: t.PASSWORDERROR,
            firstPasswordInvalid: true,
            firstPasswordState: false,
            secondPasswordState:
              stateName.secondPassword &&
              stateName.secondPassword === event.target.value,
            secondPasswordInvalid:
              stateName.secondPassword &&
              stateName.secondPassword !== event.target.value,
            secondPasswordInvalidError:
              stateName.secondPassword &&
                stateName.secondPassword !== event.target.value
                ? t.CONFIRMPASSWORDERROR
                : stateName.secondPassword &&
                  stateName.secondPassword === event.target.value
                  ? ' '
                  : stateName.secondPasswordInvalidError,
          });
        } else {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            firstPasswordInvalidError: '',
            firstPasswordInvalid: false,
            firstPasswordState: true,
            secondPasswordState:
              stateName.secondPassword &&
              stateName.secondPassword === event.target.value,
            secondPasswordInvalid:
              stateName.secondPassword &&
              stateName.secondPassword !== event.target.value,
            secondPasswordInvalidError:
              stateName.secondPassword &&
                stateName.secondPassword !== event.target.value
                ? t.CONFIRMPASSWORDERROR
                : stateName.secondPassword &&
                  stateName.secondPassword === event.target.value
                  ? ' '
                  : stateName.secondPasswordInvalidError,
          });
        }
        break;
      case 'secondPassword':
        if (event.target.value !== stateName.firstPassword) {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            secondPasswordInvalidError: t.CONFIRMPASSWORDERROR,
            secondPasswordInvalid: true,
            secondPasswordState: false,
          });
        } else {
          setStateMethod({
            ...stateName,
            [event.target.name]: event.target.value,
            secondPasswordInvalidError: ' ',
            secondPasswordInvalid: false,
            secondPasswordState: true,
          });
        }
        break;
      default:
        setStateMethod({
          ...stateName,
          [event.target.name]: event.target.value,
        });
    }
  };
  const EnableHandler = () => {
    if (stateName.firstPasswordState && stateName.secondPasswordState) {
    }
  };

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get('q');
    if (token) {
      dispatch(validateInvitationApi(token)).then((res) => {
        if (res?.payload?.success === false) {
          console.log(res?.payload?.status);
          if (res?.payload?.status == 410) {
            navigate('/link-expired');
          } else if (res?.payload?.status === 400 || res?.payload?.status === 401) {
            navigate('/invalid-link');
          } else {
            navigate('/invalid-link');
          }
        } else {
          setIsValidating(false);
        }
      });
    } else {
      navigate('/invalid-link');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const CheckValidation = async () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get('q');

    console.log(token);
    dispatch(
      CoUserAcceptInvitationApi({
        id: token,
        requestHeaders: { newPassword: stateName.firstPassword },
      }),
    )
      .then(async (data) => {
        if (typeof data.payload === 'undefined') {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        } else if (data?.payload?.status === 200) {
          toast.success("User successfully joined");
          navigate('/login');
        } else if (data?.payload?.status === 500) {
          toast.error('Some Error Occured. Please try again later.', {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
          });
        }
      })
      .catch(async (error) => {
        toast.error(error, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: 'light',
        });
      });
  };

  if (isValidating) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          width: '100%',
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  return (
    <div className="AgentPassword-Main-Container">
      <Navbar />
      <div className="Forget-main-container">
        <div className="inputDivStyle-forget">
          <div className="textDiv">
            <p className="text__create_agent">Create new password</p>
            <p className="text__start_agent">
              Welcome back! Please enter your details.
            </p>
          </div>
          <div>
            <PasswordField
              name="firstPassword"
              id="firstPassword"
              type="Password"
              title={t.ENTR_PWD}
              placeholder={t.ENTR_PASS_PH}
              value={stateName.firstPassword}
              onChange={(e) => handleChange(e)}
              error={stateName.firstPasswordInvalidError}
              className={clsx(
                stateName.firstPasswordInvalid ? 'input__error' : '',
                stateName.firstPasswordState ? 'input__success' : '',
              )}
            />
            <br />
            <PasswordField
              name="secondPassword"
              id="secondPassword"
              type="password"
              title={t.ENTR_PWD_C}
              placeholder={t.REENTR_PASS_PH}
              value={stateName.secondPassword}
              onChange={(e) => handleChange(e)}
              error={stateName.secondPasswordInvalidError}
              className={clsx(
                stateName.secondPasswordInvalid ? 'input__error' : ' ',
                stateName.secondPasswordState ? 'input__success' : ' ',
              )}
            />
          </div>
          <div className="btn-class">
            <ButtonMain
              onClick={() => {
                EnableHandler(), CheckValidation();
              }}
              disabled={!(stateName.firstPasswordState && stateName.secondPasswordState)}
              title="Save"
              className={
                stateName.firstPasswordState && stateName.secondPasswordState
                  ? 'buttonStyleEnable'
                  : 'buttonStyleDisabled'
              }
            />
          </div>
        </div>
      </div>
      <FooterTrustChat />
    </div>
  );
}

export default AgentPassword;
